import apiClient from './apiClient';

export async function setup(url: string = window.location.href) {
  const response = await apiClient.base.weixinSign({
    url
  });

  if (!response.body) {
    return;
  }

  window.wx.config({
    ...response.body,
    jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'chooseWXPay']
  });
}

function weixinAPIRunner(runner: () => void) {
  if (typeof window.WeixinJSBridge === 'undefined') {
    document.addEventListener('WeixinJSBridgeReady', runner, false);
  } else {
    runner();
  }
}

interface ShareInfo {
  title?: string; // 分享标题
  desc?: string; // 分享描述
  link?: string; // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
  imgUrl: string; // 分享图标
}

export function useShare(shareInfo: ShareInfo) {
  function share() {
    const link = shareInfo.link || window.location.href;

    window.wx.ready(() => {
      window.wx.onMenuShareTimeline({
        ...shareInfo,
        link,
        title: shareInfo.title || document.title
      });
      window.wx.onMenuShareAppMessage({
        ...shareInfo,
        link,
        title: shareInfo.title || document.title
      });
    });
  }

  weixinAPIRunner(share);
}
